import { Helmet } from "react-helmet-async";
import CheckoutLoading from "@/components/CheckoutLoading";

/**
 * Standalone branded interstitial for the checkout hand-off route.
 */
const CheckoutRedirect = () => (
  <>
    <Helmet>
      <title>Preparing your order | Rogue Skull Games</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <main className="min-h-screen bg-dark flex flex-col items-center justify-center">
      <CheckoutLoading />
    </main>
  </>
);

export default CheckoutRedirect;
